import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static targets = ["form"]
    static values = {
        message: { type: String, default: "Are you sure?" },
        agreeText: { type: String, default: "Yes" },
        disagreeText: { type: String, default: "No" }
    }

    confirm(event) {
        event.preventDefault()

        bootbox.confirm({
            message: this.messageValue,
            buttons: {
                confirm: {
                    label: this.agreeTextValue,
                    className: 'btn-success'
                },
                cancel: {
                    label: this.disagreeTextValue,
                    className: 'btn-secondary'
                }
            },
            callback: (result) => {
                if (result) {
                    this.formTarget.submit()
                }
            }
        });
    }
}

